import {CommonRootState} from '../types';

export const selectMyAcuriteConnectedAt = (state: CommonRootState) =>
  state.myAcurite.link && state.myAcurite.link.date_connected;

export const selectMyAcuriteConnected = (state: CommonRootState) =>
  state.myAcurite.link !== null;

export const selectMyAcuriteActive = (state: CommonRootState) =>
  state.myAcurite.link !== null && state.myAcurite.link.account.active;
